// models

import type {
  ReqEntrySearch,
  ReqEntryBatchInsert,
  EntryTypeDto,
  ReqEntryHistorySearch,
  ReqAttendanceCount
} from '../models/entry.model';
import { ReqEntryHistoryMonthly } from '../models/history/monthly.model';
import { ReqEntryHistoryToday } from '../models/history/today.model';
import { ReqEntryHistoryWeekly } from '../models/history/weekly.model';

/**
 * Entry 관련 Query Keys
 *
 * @description
 * 출역 관련 query-key들을 관리합니다.
 */
export const entryKeys = {
  /** ALL */
  ENTRY_ALL: ['entry'],

  /** 출역 이력 페이지 조회 */
  GET_ENTRY_PAGE: (params?: ReqEntrySearch) => ['entry', 'getEntryPage', JSON.stringify(params)],

  /** 출입 엔트리 배치 등록 */
  ENROLL_BATCH_ENTRY: (params?: ReqEntryBatchInsert) => [
    'entry',
    'enrollBatchEntry',
    JSON.stringify(params)
  ],

  /** 출입 엔트리 관리 */
  MANAGE_ENTRY: (mac?: string, params?: EntryTypeDto) => [
    'entry',
    'manageEntry',
    mac,
    JSON.stringify(params)
  ],

  /** 출입 인원 수 조회 */
  GET_ATTENDANCE_COUNT: (data: ReqAttendanceCount) => [
    'entry',
    'getAttendanceCount',
    JSON.stringify(data)
  ],

  /** 주간 총 합계 조회 */
  GET_TOTAL_COUNT_WEEKLY: (entryDate: string) => ['entry', 'getTotalCountWeekly', entryDate],

  /** 사용자 개인 출역 이력 조회 */
  GET_ENTRY_HISTORY: (userId: string, params?: Omit<ReqEntryHistorySearch, 'userId'>) => [
    'entry',
    'getEntryHistory',
    userId,
    JSON.stringify(params)
  ],

  /** 작업자 ID를 통한 출입 목록 조회 */
  GET_ENTRY_LIST_BY_WORKER_ID: (userId: string, params?: ReqEntrySearch) => [
    'entry',
    'getEntryListByWorkerId',
    userId,
    JSON.stringify(params)
  ],

  /** 금일 출입 이력 통계 조회 */
  GET_ENTRY_HISTORY_TODAY: (params: ReqEntryHistoryToday) => [
    'entry',
    'getEntryHistoryToday',
    JSON.stringify(params)
  ],

  /** 주간 출입 이력 통계 조회 */
  GET_ENTRY_HISTORY_WEEKLY: (params: ReqEntryHistoryWeekly) => [
    'entry',
    'getEntryHistoryWeekly',
    JSON.stringify(params)
  ],

  /** 월간 출입 이력 통계 조회 */
  GET_ENTRY_HISTORY_MONTHLY: (params: ReqEntryHistoryMonthly) => [
    'entry',
    'getEntryHistoryMonthly',
    JSON.stringify(params)
  ]
};
